module.exports = __webpack_public_path__ + "img/no-candidate-found.46e621ce.svg";